import styled from "styled-components";

export const Heading2 = styled.div`
  font-family: "PressStart2P",serif;
  font-size: 28px;
  line-height: 36px;
  
  @media only screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
  @media only screen and (min-width: 600px) {
    font-size: 20px;
    line-height: 24px;
  }
  @media only screen and (min-width: 768px) {
    font-size: 24px;
    line-height: 28px;
  }
  @media only screen and (min-width: 992px) {
    font-size: 28px;
    line-height: 36px;
  }
`;
